import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import containerTypes from 'apps/analytics/utils/containerTypes';
import RelatedFopsContainer from 'apps/products/containers/RelatedFopsContainer';
import SectionType from 'apps/catalogue/models/SectionType';
import getProductsBySku from 'apps/products/utils/getProductsBySku';

import { wa } from 'apps/analytics';
import { pageEvents } from 'apps/products/analytics';
import sendSingleSectionProductImpressions from 'apps/products/utils/sendSingleSectionProductImpressions';

const gtmPageType = 'Back of pack';
const section = {
  attributes: {
    type: SectionType.YOU_MIGHT_LIKE,
    title: 'Similar Products',
  },
};

const SimilarProducts = ({ isProductInStock, productDetails }) => {
  const { criteoSponsoredProducts, similarProducts = {} } = productDetails;
  const similarProductsSections = similarProducts.sections || [];
  const similarProductsFirstSection = similarProductsSections[0];
  const hasSimilarProducts = similarProductsSections.length > 0;

  const shouldRender = !criteoSponsoredProducts && hasSimilarProducts;

  useEffect(sendAnalytics, [hasSimilarProducts]);

  function sendAnalytics() {
    if (!shouldRender) {
      return;
    }

    wa.triggerPageEventWithDescription(pageEvents.BOP_SIMILAR_PRODUCTS_SHOWN);
    sendSingleSectionProductImpressions(similarProductsFirstSection, gtmPageType, section);
  }

  if (!shouldRender) {
    return null;
  }

  return (
    <section className="bop-section bop-fops" id="similarProductsScrollId">
      <h3 className="bop-fops__header">
        {isProductInStock ? 'Similar products' : 'Alternatives'}
      </h3>
      <div className="bop-fops__wrapper">
        <div className="bop-fops__items">
          <RelatedFopsContainer
            containerType={isProductInStock ? containerTypes.SIMILAR_PRODUCTS : containerTypes.ALTERNATIVES}
            fopCollection={similarProductsFirstSection}
            gtmPageType={gtmPageType}
            productsBySku={getProductsBySku(similarProductsFirstSection)}
            skipAnalytics
          />
        </div>
      </div>
    </section>
  );
};

SimilarProducts.propTypes = {
  isProductInStock: PropTypes.bool,
  productDetails: PropTypes.object,
};

export default SimilarProducts;
